import { createSelector } from "reselect";

import moment from "moment";

const createSelectors = parentReducer => {
    return new (class {
        selectBroadcasts = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["NewsBroadcastWidget_reducer"];
            return reducer.broadcasts;
        };

        selectActiveBroadcast = createSelector(
            [this.selectBroadcasts],
            (broadcasts = false) => {
                if (broadcasts) {
                    let times = Object.keys(broadcasts).map(timestamp =>
                        moment(timestamp, "DD-MM-YYYY hh:mm:ss")
                    );
                    let mostRecent = moment.max(times);
                    return broadcasts[mostRecent._i];
                } else {
                    return false;
                }
            }
        );
    })();
};
export default createSelectors;
